<script setup lang="ts">
import { AlertType } from '~/types/common'

const props = defineProps<{
	type?: AlertType
	html?: string
}>()

const bg = ref<string>('bg-yellow-50')
const text = ref<string>('text-yellow-800')
const icon_text = ref<string>('text-yellow-400')
const icon = ref<string>('ph:warning-duotone')

onMounted(() => {
	switch (props.type) {
		case AlertType.Error:
			bg.value = 'bg-red-50'
			text.value = 'text-red-700'
			icon_text.value = 'text-red-400'
			icon.value = 'ph:warning-circle-duotone'
			break
		case AlertType.Success:
			bg.value = 'bg-green-50'
			text.value = 'text-green-700'
			icon_text.value = 'text-green-400'
			icon.value = 'ph:check-circle-duotone'
			break
		case AlertType.Warning:
		default:
			break
	}
})
</script>

<template>
	<div :class="`rounded-md ${bg} pl-4 pr-4 pt-4 pb-2`">
		<div class="flex">
			<div class="shrink-0">
				<Icon :name="icon" :class="`size-5 ${icon_text}`" aria-hidden="true" />
			</div>
			<div class="ml-3">
				<div :class="`text-sm ${text}`">
					<span v-if="html" v-html="html"></span>
					<slot v-else></slot>
				</div>
			</div>
		</div>
	</div>
</template>
